import { formatDate } from 'base/src/utils/stringUtil';
import * as S from '../styles';
import { CampanhaPedidoExtratoResponse } from '../../../../../types/campanhaPedidoExtrato/campanhaPedidoExtratoResponse';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetComprovantePdf } from '../../../../../store/campanha/action/campanhaAction';
import { Icon } from '@iconify/react';

export interface TabExtratoProps {
  campanhaPedidoExtrato: CampanhaPedidoExtratoResponse[];
  campanhaId: number;
}

// Status mapping
const getStatusLabel = (statusId: number | null): string | null => {
  if (!statusId) return null;

  const statusMap: { [key: number]: string } = {
    1: 'Solicitado',
    2: 'Aprovado',
    3: 'Não Aprovada',
    4: 'Pago/Entregue',
    5: 'Em Espera',
    6: 'Cancelado',
    7: 'Lote Alocado',
    8: 'Erro no Pagamento',
  };

  return statusMap[statusId] || null;
};

export function TabExtrato({ campanhaPedidoExtrato, campanhaId }: TabExtratoProps) {
  const dispatch = useDispatch<any>();
  const { t } = useTranslation();

  function handleDownloadComprovante(campanhaPedidoResgateId: number) {
    dispatch(GetComprovantePdf(campanhaId, campanhaPedidoResgateId, t));
  }

  if (campanhaPedidoExtrato.length === 0) {
    return (
      <div style={{ padding: '20px 0' }}>
        <S.Text>Nenhum extrato disponível</S.Text>
      </div>
    );
  }

  return (
    <S.ExtratoContainer>
      <S.ExtratoHeader>
        <S.ExtratoTitle>Histórico de Pontos</S.ExtratoTitle>
        <S.ExtratoDescription>
          Últimas movimentações de pontos do participante
        </S.ExtratoDescription>
      </S.ExtratoHeader>
      <S.ExtratoList>
        {campanhaPedidoExtrato
          .filter((item) => item.CampanhaPedidoResgateStatusID === 3 || item.CampanhaPedidoResgateStatusID === 4)
          .slice(0, 5)
          .map((item, index, array) => (
          <S.ExtratoItem key={item.ExtratoID} isLast={index === array.length - 1}>
            {item.Imagem && (
              <S.ExtratoItemImage>
                <img src={item.Imagem} alt={item.Descricao} />
              </S.ExtratoItemImage>
            )}
            <S.ExtratoItemInfo>
              <S.ExtratoItemTitle>{item.Descricao}</S.ExtratoItemTitle>
              <S.ExtratoMetaInfo>
                <S.ExtratoDate>{formatDate(item.Data)}</S.ExtratoDate>
                {item.Qtde > 0 && (
                  <S.ExtratoQuantidade>Qtd: {item.Qtde}</S.ExtratoQuantidade>
                )}
                {item.CampanhaPedidoResgateStatusID && (
                  <S.ExtratoStatusTag statusId={item.CampanhaPedidoResgateStatusID!}>
                    {getStatusLabel(item.CampanhaPedidoResgateStatusID)}
                  </S.ExtratoStatusTag>
                )}
              </S.ExtratoMetaInfo>
            </S.ExtratoItemInfo>
            <S.ExtratoItemValue>
              <S.ExtratoPointsRow>
                <S.DownloadButton
                  onClick={() => handleDownloadComprovante(item.CarteiraSaqueID!)}
                  title={t("Baixar Comprovante")}
                  disabled={item.CampanhaPedidoResgateStatusID !== 4 || !item.CarteiraSaqueID}
                >
                  <Icon icon="ph:download" width={18} />
                </S.DownloadButton>
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <S.ExtratoPoints isPositive={item.Entrada}>
                    {item.Entrada ? '+' : '-'}{Math.abs(item.Pontuacao)}
                  </S.ExtratoPoints>
                  <S.ExtratoPointsLabel>pts</S.ExtratoPointsLabel>
                </div>
              </S.ExtratoPointsRow>
            </S.ExtratoItemValue>

          </S.ExtratoItem>
        ))}
      </S.ExtratoList>
    </S.ExtratoContainer>
  );
}
